import { formatToLocalDate, formatToIsoDate } from '@/utils';

export default {
  name: 'TimeEstimationsInfo',
  components: {},
  props: {
    inputForm: {
      type: Object,
      default: undefined,
    },
    inputFormType: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    firstDatepickerEtStart: null,
    firstDatepickerEtEnd: null,
    firstDatepickerAtStart: null,
    firstDatepickerAtEnd: null,
    formFields: {
      firstDatepickerEtStart: {
        name: 'firstDatepickerEtStart',
        label: 'ET start',
      },
      firstDatepickerEtEnd: {
        name: 'firstDatepickerEtEnd',
        label: 'ET end',
      },
      firstDatepickerAtStart: {
        name: 'firstDatepickerAtStart',
        label: 'At start',
      },
      firstDatepickerAtEnd: {
        name: 'firstDatepickerAtEnd',
        label: 'At end',
      },
    },
  }),
  computed: {
    showDefaultState() {
      const hideDefaultTimes = ['ShippingAgent', 'Nomination', 'CargoOperations'];
      return !hideDefaultTimes.includes(this.inputFormType);
    },
    hideblock() {
      return this.inputFormType === 'ShippingAgent' || this.inputFormType === 'CargoOperations';
    },
    showDossierState() {
      return this.inputFormType === 'Nomination';
    },
  },
  methods: {
    setLabels() {
      if (this.showDefaultState) {
        this.formFields.firstDatepickerEtStart.label = 'ET start';
        this.formFields.firstDatepickerEtEnd.label = 'ET end';
        this.formFields.firstDatepickerAtStart.label = 'At start';
        this.formFields.firstDatepickerAtEnd.label = 'At end';
      } else if (this.showDossierState) {
        this.formFields.firstDatepickerEtStart.label = 'Loading laycan ET start';
        this.formFields.firstDatepickerEtEnd.label = 'Loading laycan ET end';
        this.formFields.firstDatepickerAtStart.label = 'Discharge window ET start';
        this.formFields.firstDatepickerAtEnd.label = 'Discharge window ET end';
      }
    },
    onInputFormSaved() {
      const postObject = {
        dateTimeWindow1: {},
        dateTimeWindow2: {},
      };

      if (this.showDossierState) {
        postObject.dateTimeWindow1.beginEstimate = formatToIsoDate(this.firstDatepickerEtStart);
        postObject.dateTimeWindow1.endEstimate = formatToIsoDate(this.firstDatepickerEtEnd);

        postObject.dateTimeWindow2.beginEstimate = formatToIsoDate(this.firstDatepickerAtStart);
        postObject.dateTimeWindow2.endEstimate = formatToIsoDate(this.firstDatepickerAtEnd);
      } else if (this.showDefaultState) {
        postObject.dateTimeWindow1.beginEstimate = formatToIsoDate(this.firstDatepickerEtStart);
        postObject.dateTimeWindow1.endEstimate = formatToIsoDate(this.firstDatepickerEtEnd);

        postObject.dateTimeWindow1.beginActual = formatToIsoDate(this.firstDatepickerAtStart);
        postObject.dateTimeWindow1.endActual = formatToIsoDate(this.firstDatepickerAtEnd);
      }

      this.$eventHub.$emit('fetch-time-estimations-info', postObject);
    },
  },
  watch: {
    inputForm() {
      if (this.inputForm != null) {
        if (this.inputForm.inputType === 'Nomination') {
          // loading laycan & Discharge window
          this.firstDatepickerEtStart = formatToLocalDate(this.inputForm.dateTimeWindow1.beginEstimate);
          this.firstDatepickerEtEnd = formatToLocalDate(this.inputForm.dateTimeWindow1.endEstimate);
          this.firstDatepickerAtStart = formatToLocalDate(this.inputForm.dateTimeWindow2.beginEstimate);
          this.firstDatepickerAtEnd = formatToLocalDate(this.inputForm.dateTimeWindow2.endEstimate);
        }

        const hideDefaultTimes = ['ShippingAgent', 'Nomination', 'CargoOperations'];
        if (!hideDefaultTimes.includes(this.inputForm.inputType)) {
          this.firstDatepickerEtStart = formatToLocalDate(this.inputForm.dateTimeWindow1.beginEstimate);
          this.firstDatepickerEtEnd = formatToLocalDate(this.inputForm.dateTimeWindow1.endEstimate);
          this.firstDatepickerAtStart = formatToLocalDate(this.inputForm.dateTimeWindow1.beginActual);
          this.firstDatepickerAtEnd = formatToLocalDate(this.inputForm.dateTimeWindow1.endActual);
        }
      }
    },
    inputFormType() {
      this.setLabels();
    },
  },
  created() {
    this.$eventHub.$on('on-input-form-saved', this.onInputFormSaved);
  },
};
